var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('andes-header'),_c('breadcrumb',{attrs:{"activePage":"2"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('extras-message')],1),_c('div',{staticClass:"col-sm-3"},[_c('summary-form',{attrs:{"onContinue":_vm.onContinue}})],1)])]),_c('andes-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }